import { isNullable } from '~/utils/commonUtils';
import type { Review } from '~~/shared/globalTypes/reviews';

export const provideReviewDefaults = <T extends Review, K extends keyof T>(data: T, prop: K, defaultVal: T[K], isMandatory: boolean = true) => {
  if (!(prop in data) || isNullable(data[prop])) {
    if (isMandatory)
      if (!import.meta.server) {
        console.warn(
          `mandatory review field, ${prop as string}, is missing or unproperly defined in the data and will be provided a default value. Please contact PDP XAPI / DRS team so the correct reviews data will display on the screen`,
        );
      }
    return defaultVal;
  }

  return data[prop];
};
